import { downloadCsv } from '../../lib/csv';

export default function ExportButton({
  filename,
  columns,
  rows,
}: {
  filename: string;
  columns: string[];
  rows: (string | number)[][];
}) {
  return (
    <button
      type="button"
      onClick={() => downloadCsv(filename, columns, rows)}
      className="px-3 py-1.5 text-xs font-semibold border border-background-300 rounded-md hover:border-accent-400"
    >
      导出 CSV
    </button>
  );
}
